import image1 from "./00.jpg";
import image2 from "./01.jpg"
import image3 from "./02.jpg"
import image4 from "./03.jpg"
import image5 from "./04.jpg"
import image6 from "./05.jpg"
import image7 from "./06.jpg"
import image8 from "./07.jpg"
import image9 from "./08.jpg"
import image10 from "./09.jpg"

const galleryImagesList = [

    {
        img: image1,
        title: 'Pizzeria La Bruschetta Supersano - La nostra sala',
        rows: 2,
        cols: 2
    },
    {
        img: image2,
        title: 'Pizzeria La Bruschetta Supersano - Antipasti',
        rows: 1,
        cols: 1
    },
    {
        img: image3,
        title: 'Pizzeria La Bruschetta Supersano - Il forno',
        rows: 2,
        cols: 1
    },
    {
        img: image4,
        title: 'Pizzeria La Bruschetta Supersano - Calzoni ripieni',
        rows: 1,
        cols: 2
    },
    {
        img: image5,
        title: 'Pizzeria La Bruschetta Supersano - Le pucce',
        rows: 1,
        cols: 1
    },
    {
        img: image6,
        title: 'Pizzeria La Bruschetta Supersano - Pizze Speciali',
        rows: 2,
        cols: 2
    },
    {
        img: image7,
        title: 'Pizzeria La Bruschetta Supersano - Pizze',
        rows: 2,
        cols: 1
    },
    {
        img: image8,
        title: 'Pizzeria La Bruschetta Supersano - La nostra sala',
        rows: 1,
        cols: 2
    },
    {
        img: image9,
        title: 'Pizzeria La Bruschetta Supersano - Rosticceria',
        rows: 2,
        cols: 2
    },
    {
        img: image10,
        title: 'Pizzeria La Bruschetta Supersano - Pizza ai frutti di mare',
        rows: 2,
        cols: 1
    },
];

export default galleryImagesList